import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames/bind'
import { Text, utils } from '@adc/ui-adc'
import styles from './styles.scss'
const cx = classnames.bind(styles)
const formatMoney = utils.formatters.formatMoney

export const WinningBid = ({
  winningBidAmount,
  labelText = 'Your Winning Bid',
}) => {
  return (
    <div className={cx('label-value', 'u-mb-3')}>
      <Text color='gray' content={labelText} data-elm-id='winning_bid_label' />
      <Text
        color='gray'
        content={formatMoney(winningBidAmount)}
        data-elm-id='winning_bid_value'
        weight='heavy'
      />
    </div>
  )
}

WinningBid.propTypes = {
  winningBidAmount: PropTypes.number,
  labelText: PropTypes.string,
}

export const PreviousBid = ({
  previousBidAmount,
  labelText = 'Your previous bid',
}) => {
  return (
    <div className={cx('label-value', 'u-mb-3')}>
      <Text color='gray' content={labelText} data-elm-id='previous_bid_label' />
      <Text
        color='gray'
        content={formatMoney(previousBidAmount)}
        data-elm-id='previous_bid_value'
      />
    </div>
  )
}

PreviousBid.propTypes = {
  previousBidAmount: PropTypes.number,
  labelText: PropTypes.string,
}

export const BuyersPremiumAndTotal = ({ listing, bidAmount, hasError }) => {
  const { buyersPremium, totalPurchasePrice } =
    listing.__methods__.getCostCalculations(bidAmount)

  return (
    Boolean(buyersPremium) &&
    listing.__methods__.isUsingSellerLevelFees() && (
      <>
        <div className={cx('label-value', 'u-mb-3')}>
          <Text
            color='gray'
            content="Buyer's Premium"
            data-elm-id='buyers_premium_label'
          />
          <Text
            color='gray'
            content={hasError ? '–' : formatMoney(buyersPremium)}
            data-elm-id='buyers_premium_value'
            weight='heavy'
          />
        </div>
        <div className={cx('divider', 'u-mb-3')} />
        <div className={cx('label-value', 'u-mb-3')}>
          <Text
            color='gray'
            content='Total Purchase Price'
            data-elm-id='total_purchase_price_label'
            weight='heavy'
          />
          <Text
            color='gray'
            content={hasError ? '–' : formatMoney(totalPurchasePrice)}
            data-elm-id='total_purchase_price_value'
            weight='heavy'
          />
        </div>
      </>
    )
  )
}

BuyersPremiumAndTotal.propTypes = {
  listing: PropTypes.object.isRequired,
  bidAmount: PropTypes.number,
  hasError: PropTypes.bool,
}
